import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { BodyLarge } from "../atoms/Bodies"
import React from "react"
import { Stack, useTheme } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { ZendeskArrowLink } from "../atoms/links/ZendeskArrowLink"

export function SupportCenterModule(): JSX.Element {
  const theme = useTheme()
  return (
    <RoundedRectangle id="home-sidebar-support-center-module" backgroundColor="pampas">
      <Stack spacing={theme.spacing(theme.tokens.spacing.md)}>
        <BodyLarge color="black-80" font="publico-headline">
          <FormattedMessage defaultMessage="Get answers to frequently asked questions" />
        </BodyLarge>
        <ZendeskArrowLink>
          <FormattedMessage defaultMessage="Visit Support Center" />
        </ZendeskArrowLink>
      </Stack>
    </RoundedRectangle>
  )
}
